/*
 * Copyright (c) Dito Technologies
 */

import {graphql} from "babel-plugin-relay/macro";

export default graphql`
    query LibraryQuery {
        music_viewer {
            ...LibraryRows_musicViewer
        }
    }
`;